import * as angular from 'angular';

import firebase from 'firebase/app';
import 'firebase/messaging';

(function () {
    'use strict';

    angular.module('app').service('WebPushService', WebPushService);

    function WebPushService($log, $state, GcmFactory, toastr) {
        this.runFirebaseMessaging = function () {
            if (!navigator.serviceWorker) {
                $log.warn(
                    "Your browser doesn't support ServiceWorkers. No serviceWorker in Navigator."
                );
                return;
            }

            try {
                const firebaseMessaging = firebase.messaging();

                setVAPIDkey(firebaseMessaging);
                askForPermission(firebaseMessaging);
                updateTokenWhenItRefreshes(firebaseMessaging);
                displayNotificationWhenItArrives(firebaseMessaging);
            } catch (err) {
                $log.warn('Cannot reach firebase.messaging().');
            }
        };

        function setVAPIDkey(firebaseMessaging) {
            if (firebaseMessaging.publicVapidKeyToUse) {
                return;
            }

            firebaseMessaging.usePublicVapidKey(
                'BN33pPhMRqRESH18eg_4iqPgJz8WvoBLWknCy3sR5BTcUlcTwqZygyoLQQxnQUpgTQc_B3QB-Oy7WXtdsfNge8Y'
            );
        }

        function askForPermission(firebaseMessaging) {
            firebaseMessaging.requestPermission().then(
                function () {
                    getTokenAndSaveOnServer(firebaseMessaging);
                },
                function (err) {
                    $log.error(err);
                }
            );
        }

        function updateTokenWhenItRefreshes(firebaseMessaging) {
            firebaseMessaging.onTokenRefresh(function () {
                getTokenAndSaveOnServer(firebaseMessaging);
            });
        }

        function displayNotificationWhenItArrives(firebaseMessaging) {
            firebaseMessaging.onMessage(function (receivedNotification) {
                var notificationBody = receivedNotification.notification.body;
                var notificationAdditionalData = receivedNotification.data;

                toastr.success(notificationBody, {
                    timeOut: 6000,
                    onTap: function () {
                        if (notificationAdditionalData.issue_id) {
                            $state.go('company_employee.issue_list.details', {
                                issue_id: notificationAdditionalData.issue_id,
                            });
                            return;
                        }
                    },
                });
            });
        }

        function getTokenAndSaveOnServer(firebaseMessaging) {
            firebaseMessaging.getToken().then(function (registrationToken) {
                GcmFactory.create({
                    registration_id: registrationToken,
                    cloud_message_type: 'FCM',
                    name: 'Browser',
                });
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/web_push.service.ts